<template>
  <div>
    <div class="row mb-2">
      <div class="col-md-6 col-sm-12 mb-2">
        <label class="form-label font-weight-bold">
          Principio Activo <span class="text-danger">*</span>
        </label>
        <v-select-medication-dci
          v-model="selectedDci"
          mode="object"
        ></v-select-medication-dci>
        <small class="text-danger" v-if="submitted && !selectedDci">
          El principio activo es obligatorio.
        </small>
      </div>

      <div class="col-md-6 col-sm-12 mb-2">
        <label class="form-label font-weight-bold">Medicamento / Nombre Comercial</label>
        <input
          type="text"
          v-model="selectedConcepto"
          class="form-control form-control-sm"
          placeholder="Ej. Naproxeno"
        />
      </div>

      <div class="col-md-6 col-sm-6 mb-2">
        <label class="form-label font-weight-bold">Dosis</label>
        <input
          type="text"
          v-model="selectedDosis"
          class="form-control form-control-sm"
          placeholder="Ej. 850 mg"
        />
      </div>

      <div class="col-md-6 col-sm-6 mb-2">
        <label class="form-label font-weight-bold">Frecuencia</label>
        <input
          type="text"
          v-model="selectedFrecuencia"
          class="form-control form-control-sm"
          placeholder="Ej. Cada 12 horas"
        />
      </div>
    </div>

    <div class="row align-items-end mb-3">
      <div class="col-12 text-right">
        <button type="button" class="btn btn-primary btn-sm" @click="addMedication">
          <i class="fa fa-plus fa-fw"></i> Agregar Medicamento
        </button>
      </div>
    </div>

    <div v-if="value.length > 0" class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead class="bg-light">
          <tr>
            <th>Principio Activo</th>
            <th>Medicamento / Comercial</th>
            <th>Dosis</th>
            <th>Frecuencia</th>
            <th class="text-center" style="width: 50px;">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in value" :key="index">
            <td>
              <strong>
                {{
                  item.medicamentoDci
                    ? item.medicamentoDci.nombre
                    : (item.medicamento_dci
                        ? item.medicamento_dci.nombre
                        : item.concepto || 'N/A')
                }}
              </strong>
            </td>
            <td>{{ item.concepto || 'N/A' }}</td>
            <td>{{ item.dosis || 'N/A' }}</td>
            <td>{{ item.frecuencia || 'N/A' }}</td>
            <td class="text-center">
              <button type="button" class="btn btn-danger btn-xs" @click="removeMedication(index)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import VSelectMedicationDci from '../common/VSelectMedicationDci.vue';

export default {
  name: 'MedicationDetail',
  components: {
    VSelectMedicationDci
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedDci: null,
      selectedConcepto: '',
      selectedDosis: '',
      selectedFrecuencia: '',
      submitted: false
    };
  },
  methods: {
    addMedication() {
      this.submitted = true;
      if (!this.selectedDci) {
        return;
      }

      const dciId = typeof this.selectedDci === 'object' ? this.selectedDci.id : this.selectedDci;
      const dciObj = typeof this.selectedDci === 'object' ? this.selectedDci : null;

      const newDetail = {
        tipo_detalle: 'MEDICATION',
        id_medicamento: dciId,
        medicamentoDci: dciObj,
        concepto: this.selectedConcepto,
        dosis: this.selectedDosis,
        frecuencia: this.selectedFrecuencia
      };

      this.$emit('input', [...this.value, newDetail]);

      this.selectedDci = null;
      this.selectedConcepto = '';
      this.selectedDosis = '';
      this.selectedFrecuencia = '';
      this.submitted = false;
    },
    removeMedication(index) {
      const updated = [...this.value];
      updated.splice(index, 1);
      this.$emit('input', updated);
    }
  }
};
</script>
